import { h } from 'preact';
import ProductCardSwatches from './card/product-swatches';
import ProductMainSwatches from './main/product-swatches';

const ProductSwatches = ({ viewType, ...props }) => {
  if (viewType === 'card') {
    return <ProductCardSwatches {...props} />;
  }
  return <ProductMainSwatches {...props} />;
};

export default ProductSwatches;
